import axiosPrivate from "@services/axiosPrivate"
import { ORDER_VERIFY_URL } from "src/constants"

export const verifyOrder = async (data) => {
  return axiosPrivate.post(ORDER_VERIFY_URL, data)
}
